import { createSelector } from 'reselect';
import getDeeplink from './getDeepLink';

const shouldShowLocationPointToast = createSelector(
  getDeeplink,
  deepLink => deepLink === null && deepLink?.from === undefined,
);

export default shouldShowLocationPointToast;
